import { useMemo } from 'react';

import { allProducts } from 'helpers/fakeData';

export const useGetMarketPlaceProduct = (productId?: string) => {
  return useMemo(() => {
    return allProducts.find((product) => product.id === productId);
  }, [productId]);
};
